module.exports = __webpack_public_path__ + "img/ic_add_photo_default.ac5bd123.svg";